import { Cidade, ContatoFornecedor, error99, Estado, Fornecedor, FornecedorAttributes, FornecedorSearchBox, RetAPI } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const FornecedorService = {

    /*
        FilterRelatorio: async (filterFornecedor?: any): Promise<Fornecedor[]> => {
    
            const resp = await Api('Fornecedor/Report/Filter', 'get', {
    
                datai: filterFornecedor.datai,
                dataf: filterFornecedor.dataf,
                ativo: filterFornecedor.ativo,
                id_cidade: filterFornecedor.id_cidade,
                uf: filterFornecedor.uf,
                fisica_juridica: filterFornecedor.fisica_juridica
    
            })
            const fornecedor: Fornecedor[] = []
    
    
            if (resp.data) {
    
                if (resp.data.error && resp.data.error === '0') {
                    resp.data.fornecedores.map((item: any) => {
                        return fornecedor.push({
    
                            id: item.id,
                            id_user_insert: item.id_user_insert,
                            id_user_last_update: item.id_user_last_update,
                            tipo_pessoa: item.tipo_pessoa,
                            cnpj_cpf: item.cnpj_cpf,
                            nome: item.nome,
                            nome_fantasia: item.nome_fantasia,
                            ie_rg: item.ie_rg,
                            ativo: item.ativo,
                            observacao: item.observacao,
                            cep: item.cep,
                            endereco: item.endereco,
                            bairro: item.bairro,
                            numero: item.numero,
                            complemento: item.complemento,
                            uf: item.uf,
                            id_cidade: item.id_cidade,
                            nome_cidade: item.nome_cidade,
                            id_origem: item.id_origem,
                            description: item.nome,
                            dt_cadastro: item.dt_cadastro,
                            dt_last_update: item.dt_last_update,
                            name_user_insert: item.name_user_insert,
                            name_user_last_update: item.name_user_last_update
    
                        })
                    })
    
                    return fornecedor
                } else {
                    return []
                }
            } else {
                return []
            }
    
        },
        */

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('Fornecedor/Attributes', 'get', { id })
        const attributes: FornecedorAttributes = {
            estados: [],
            cidades: [],
            fornecedor: {
                id: 0,
                id_empresa: 0,
                id_origem: 0,
                id_user_insert: 0,
                id_user_last_update: 0,
                id_user_exclusao: 0,
                dt_cadastro: '',
                dt_last_update: '',
                dh_exclusao: '',
                motivo_exclusao: '',
                description: '',
                endereco: '',
                bairro: '',
                cep: '',
                id_cidade: 0,
                ativo: true,
                cnpj_cpf: '',
                nome: '',
                nome_fantasia: '',
                numero: '',
                observacao: '',
                tipo_pessoa: '',
                uf: '',
                ie_rg: '',
                nome_cidade: '',
                complemento: '',
                name_user_insert: '',
                name_user_last_update: '',
                name_user_delete: ''
            }
        }

        if (resp.data) {

            let estados: Estado[] = []
            let cidades: Cidade[] = []

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.estados) {
                    estados = resp.data.estados.map((item: any) => {
                        return {
                            id: item.id,
                            description: item.nome,
                            sigla: item.sigla,
                            codIBGE: item.codIBGE,
                        }
                    })
                    attributes.estados = estados
                }

                if (resp.data.cidades) {
                    cidades = resp.data.cidades.map((item: any) => {
                        return {
                            id: item.codigo,
                            description: item.nome,
                            uf: item.uf,
                            codIBGE: item.codigo,
                        }
                    })
                    attributes.cidades = cidades
                }

                if (resp.data.fornecedor) {

                    attributes.fornecedor.id = resp.data.fornecedor.id
                    attributes.fornecedor.id_empresa = resp.data.fornecedor.id_empresa
                    attributes.fornecedor.id_origem = resp.data.fornecedor.id_origem
                    attributes.fornecedor.id_user_insert = resp.data.fornecedor.id_user_insert
                    attributes.fornecedor.id_user_last_update = resp.data.fornecedor.id_user_last_update
                    attributes.fornecedor.id_user_exclusao = resp.data.fornecedor.id_user_exclusao
                    attributes.fornecedor.dt_cadastro = resp.data.fornecedor.dt_cadastro
                    attributes.fornecedor.dt_last_update = resp.data.fornecedor.dt_last_update
                    attributes.fornecedor.dh_exclusao = resp.data.fornecedor.dh_exclusao
                    attributes.fornecedor.motivo_exclusao = resp.data.fornecedor.motivo_exclusao
                    attributes.fornecedor.description = resp.data.fornecedor.description
                    attributes.fornecedor.endereco = resp.data.fornecedor.endereco
                    attributes.fornecedor.bairro = resp.data.fornecedor.bairro
                    attributes.fornecedor.cep = resp.data.fornecedor.cep
                    attributes.fornecedor.id_cidade = resp.data.fornecedor.id_cidade
                    attributes.fornecedor.ativo = resp.data.fornecedor.ativo
                    attributes.fornecedor.cnpj_cpf = resp.data.fornecedor.cnpj_cpf
                    attributes.fornecedor.nome = resp.data.fornecedor.nome
                    attributes.fornecedor.nome_fantasia = resp.data.fornecedor.nome_fantasia
                    attributes.fornecedor.numero = resp.data.fornecedor.numero
                    attributes.fornecedor.observacao = resp.data.fornecedor.observacao
                    attributes.fornecedor.tipo_pessoa = resp.data.fornecedor.tipo_pessoa
                    attributes.fornecedor.uf = resp.data.fornecedor.uf
                    attributes.fornecedor.ie_rg = resp.data.fornecedor.ie_rg
                    attributes.fornecedor.nome_cidade = resp.data.fornecedor.nome_cidade
                    attributes.fornecedor.complemento = resp.data.fornecedor.complemento
                    attributes.fornecedor.name_user_insert = resp.data.fornecedor.name_user_insert
                    attributes.fornecedor.name_user_last_update = resp.data.fornecedor.name_user_last_update
                    attributes.fornecedor.name_user_delete = resp.data.fornecedor.name_user_delete

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }

        }

        return {
            error: false,
            data: attributes
        }
    },

    Save: async (fornecedor: any): Promise<RetAPI> => {

        let id = ''

        if (fornecedor.id) {
            id = fornecedor.id.toString()
        }

        const resp = await Api('Fornecedor/Save', 'post', {

            nome: fornecedor.nome,
            nome_fantasia: fornecedor.nome_fantasia,
            endereco: fornecedor.endereco,
            bairro: fornecedor.bairro,
            numero: fornecedor.numero,
            cep: fornecedor.cep,
            id_cidade: fornecedor.id_cidade,
            uf: fornecedor.uf,
            tipo_pessoa: fornecedor.tipo_pessoa,
            cnpj_cpf: fornecedor.cnpj_cpf,
            ie_rg: fornecedor.ie_rg,
            complemento: fornecedor.complemento,
            observacao: fornecedor.observacao,
            ativo: fornecedor.ativo,
            id_origem: fornecedor.id_origem,
            id
        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            return {
                error: false,
                msg: 'Dados do fornecedor gravados com sucesso',
                id: resp.data.fornecedor.id,
                data: resp.data,
                dt_cadastro: resp.data.fornecedor.dt_cadastro,
                dt_last_update: resp.data.fornecedor.dt_last_update,
                name_user_insert: resp.data.fornecedor.name_user_insert,
                name_user_last_update: resp.data.fornecedor.name_user_last_update,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Fornecedor/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, filterFornecedor?: any, id?: string): Promise<RetAPI> => {

        const resp = await Api('Fornecedor/Filter', 'get', {
            field,
            filter_type,
            filter,
            id,
            dt_cad_ini: filterFornecedor?.dt_cad_ini,
            dt_cad_fim: filterFornecedor?.dt_cad_fim,
            tipo_pessoa: filterFornecedor?.tipo_pessoa,
            status: filterFornecedor?.status,
            uf: filterFornecedor?.uf,
            id_cidade: filterFornecedor?.id_cidade,
        })
        const fornecedor: Fornecedor[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: fornecedor
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.fornecedores.map((item: any) => {
                    return fornecedor.push({

                        id: item.id,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        tipo_pessoa: item.tipo_pessoa,
                        cnpj_cpf: item.cnpj_cpf,
                        nome: item.nome,
                        nome_fantasia: item.nome_fantasia,
                        ie_rg: item.ie_rg,
                        ativo: item.ativo,
                        observacao: item.observacao,
                        cep: item.cep,
                        endereco: item.endereco,
                        bairro: item.bairro,
                        numero: item.numero,
                        complemento: item.complemento,
                        uf: item.uf,
                        id_cidade: item.id_cidade,
                        nome_cidade: item.nome_cidade,
                        id_origem: item.id_origem,
                        description: item.nome,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: fornecedor
            }
        }

        return {
            error: false,
            data: fornecedor
        }

    },

    FilterExcluidas: async (filterFornecedor: any): Promise<RetAPI> => {

        const resp = await Api('Fornecedor/Filter/Excluidas', 'get', {
            datai: filterFornecedor.datai,
            dataf: filterFornecedor.dataf,
            nome_fornecedor: filterFornecedor.nome_fornecedor
        })
        const fornecedor: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: fornecedor
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.fornecedores.map((item: any) => {
                    return fornecedor.push({

                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        cnpj_cpf: item.cnpj_cpf,
                        nome: item.nome

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: fornecedor
            }
        }

        return {
            error: false,
            msg: resp.data.msg || '',
            data: fornecedor,
        }

    },

    GetListFornecedor: async (): Promise<RetAPI> => {

        const resp = await Api('Fornecedor/List', 'get')
        const fornecedor: FornecedorSearchBox[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: fornecedor
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.fornecedores.map((item: any) => {
                    return fornecedor.push({

                        id: item.id,
                        description: item.nome,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: fornecedor
            }
        }

        return {
            error: false,
            data: fornecedor
        }
    },

    CreateContact: async (contato: ContatoFornecedor): Promise<RetAPI> => {

        const resp = await Api('Fornecedor/Contato/Save', 'post', {
            id: contato.id,
            nome: contato.nome,
            telefone: contato.telefone,
            celular: contato.celular,
            setor: contato.setor,
            email: contato.email,
            id_fornecedor: contato.id_fornecedor,
            id_empresa: contato.empresaId
        })

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            id: resp.data.contato.id,
            msg: 'Dados gravados com sucesso'
        }

    },

    BuscarContatos: async (id_fornecedor: number): Promise<RetAPI> => {

        const resp = await Api('Fornecedor/Contato/List', 'get', { id_fornecedor })
        let contactsList: ContatoFornecedor[] = []

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: contactsList
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || '',
                data: contactsList
            }
        }

        if (resp.data.contatos) {
            contactsList = resp.data.contatos.map((item: any) => {
                return {
                    id: item.id,
                    nome: item.nome,
                    telefone: item.telefone,
                    celular: item.celular,
                    email: item.email,
                    setor: item.setor,
                    id_fornecedor: item.fornecedorId,

                    id_user_insert: item.id_user_insert,
                    id_user_last_update: item.id_user_last_update,
                    id_user_exclusao: item.id_user_exclusao,
                    dt_cadastro: item.dt_cadastro,
                    dt_last_update: item.dt_last_update,
                    dh_exclusao: item.dh_exclusao,
                    motivo_exclusao: item.motivo_exclusao,
                    name_user_insert: item.name_user_insert,
                    name_user_last_update: item.name_user_last_update,
                    name_user_delete: item.name_user_delete

                }
            })
        }

        return {
            error: false,
            data: contactsList
        }

    },

    DeleteContato: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`Fornecedor/Contato/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    FornecedorImportacao: async (planilha: any, mapa: any): Promise<RetAPI> => {

        const formData = new FormData()
        formData.append("mapa", JSON.stringify(mapa))
        formData.append("planilha", planilha)

        const resp = await Api('Importacao/Fornecedores', 'post', formData)

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }
    }

}
